import type { FC } from "react";
import { LeapChatContentPositioner } from "./leapChat.styles";
import styled from "@emotion/styled";
import translate from "src/lib/translate";
import type { TranslationKey } from "src/types/translationKey";
import ChatDetailHeader from "./NavButton";

const Title = styled.div`
  padding: 2rem;
  font-family: "STK Bureau Serif Light", serif;
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 1.1;
  letter-spacing: -0.6px;
  color: var(--color-charcoal, #212121);
`;

const EmptyStateText = styled.p`
  padding: 0 2rem;
  font-size: 1rem;
  line-height: 1.4;
  letter-spacing: -0.32px;
  color: var(--color-charcoal-60, rgba(33, 33, 33, 0.6));
  margin: 0;
`;

const UpdatesView: FC = () => {
  return (
    <LeapChatContentPositioner>
      <ChatDetailHeader showArchive showNew />
      <Title>{translate("leapChat.updates.title" as TranslationKey)}</Title>
      <EmptyStateText>
        {translate("leapChat.updates.empty" as TranslationKey)}
      </EmptyStateText>
    </LeapChatContentPositioner>
  );
};

export default UpdatesView;
